import React from 'react';
import { SafeAreaView, StatusBar, useColorScheme } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// 导入页面
import HomeScreen from './screens/HomeScreen';
import ProfileScreen from './screens/ProfileScreen';
import HealthDataScreen from './screens/HealthDataScreen';
import GoalScreen from './screens/GoalScreen';
import FoodHomeScreen from './screens/FoodHomeScreen';
import FoodSearchScreen from './screens/FoodSearchScreen';
import FoodDetailScreen from './screens/FoodDetailScreen';
import FoodFavoritesScreen from './screens/FoodFavoritesScreen';
import PersonalNutritionScreen from './screens/PersonalNutritionScreen';
import MainMenuScreen from './screens/MainMenuScreen';
import FoodInputHomeScreen from './screens/FoodInputHomeScreen';
import FoodInputConfirmScreen from './screens/FoodInputConfirmScreen';
import HealthDataOverviewScreen from './screens/HealthDataOverviewScreen';
import NutrientDistributionScreen from './screens/NutrientDistributionScreen';
import TimeAnalysisScreen from './screens/TimeAnalysisScreen';
import FoodRecommendationScreen from './screens/FoodRecommendationScreen';

// 导入社交互动相关页面
import SocialHomeScreen from './screens/social/SocialHomeScreen';
import CommunityFeedScreen from './screens/social/CommunityFeedScreen';
import FriendListScreen from './screens/social/FriendListScreen';
import FriendComparisonScreen from './screens/social/FriendComparisonScreen';
import ChallengesScreen from './screens/social/ChallengesScreen';
import ChallengeDetailScreen from './screens/social/ChallengeDetailScreen';
import ExperienceSharingScreen from './screens/social/ExperienceSharingScreen';
import RecipeDetailScreen from './screens/social/RecipeDetailScreen';
import ExperienceDetailScreen from './screens/social/ExperienceDetailScreen';
import SupportGroupScreen from './screens/social/SupportGroupScreen';
import AchievementsScreen from './screens/social/AchievementsScreen';
import AchievementDetailScreen from './screens/social/AchievementDetailScreen';
import RankingsScreen from './screens/social/RankingsScreen';

const Stack = createNativeStackNavigator();

const App = () => {
  const isDarkMode = useColorScheme() === 'dark';

  return (
    <NavigationContainer>
      <SafeAreaView style={{ 
        flex: 1, 
        backgroundColor: isDarkMode ? '#8fa0c1' : '#ffffff',
      }}>
        <StatusBar barStyle={isDarkMode ? 'light-content' : 'dark-content'} />
        <Stack.Navigator
          initialRouteName="MainMenu"
          screenOptions={{
            headerStyle: {
              backgroundColor: isDarkMode ? '#012676' : '#2563eb',
            },
            headerTintColor: '#ffffff',
            headerTitleStyle: {
              fontWeight: 'bold',
            },
          }}
        >
          <Stack.Screen 
            name="MainMenu" 
            component={MainMenuScreen} 
            options={{ title: '主菜单' }} 
          />
          <Stack.Screen 
            name="Home" 
            component={HomeScreen} 
            options={{ title: '健康管理中心' }} 
          />
          <Stack.Screen 
            name="Profile" 
            component={ProfileScreen} 
            options={{ title: '个人中心' }} 
          />
          <Stack.Screen 
            name="HealthData" 
            component={HealthDataScreen} 
            options={{ title: '健康数据管理' }} 
          />
          <Stack.Screen 
            name="Goal" 
            component={GoalScreen} 
            options={{ title: '目标管理' }} 
          />
          
          {/* 食物管理相关页面 */}
          <Stack.Screen 
            name="FoodHome" 
            component={FoodHomeScreen} 
            options={{ title: '食物管理' }} 
          />
          <Stack.Screen 
            name="FoodSearch" 
            component={FoodSearchScreen} 
            options={{ title: '食物搜索' }} 
          />
          <Stack.Screen 
            name="FoodDetail" 
            component={FoodDetailScreen} 
            options={{ title: '食物详情' }} 
          />
          <Stack.Screen 
            name="FoodFavorites" 
            component={FoodFavoritesScreen} 
            options={{ title: '我的食物' }} 
          />
          <Stack.Screen 
            name="PersonalNutrition" 
            component={PersonalNutritionScreen} 
            options={{ title: '营养目标' }} 
          />
          
          {/* 智能食物录入相关页面 */}
          <Stack.Screen 
            name="FoodInputHome" 
            component={FoodInputHomeScreen} 
            options={{ title: '智能食物录入' }} 
          />
          <Stack.Screen 
            name="FoodInputConfirm" 
            component={FoodInputConfirmScreen} 
            options={{ title: '确认食物信息' }} 
          />
          
          {/* 数据分析相关页面 */}
          <Stack.Screen 
            name="HealthDataOverview" 
            component={HealthDataOverviewScreen} 
            options={{ title: '健康数据概览' }} 
          />
          <Stack.Screen 
            name="NutrientDistribution" 
            component={NutrientDistributionScreen} 
            options={{ title: '营养素分布分析' }} 
          />
          <Stack.Screen 
            name="TimeAnalysis" 
            component={TimeAnalysisScreen} 
            options={{ title: '时间维度分析' }} 
          />
          <Stack.Screen 
            name="FoodRecommendation" 
            component={FoodRecommendationScreen} 
            options={{ title: '食物摄入提醒与建议' }} 
          />
          
          {/* 社交互动相关页面 */}
          <Stack.Screen 
            name="SocialHome" 
            component={SocialHomeScreen} 
            options={{ title: '社交互动' }} 
          />
          <Stack.Screen 
            name="CommunityFeed" 
            component={CommunityFeedScreen} 
            options={{ title: '社区动态' }} 
          />
          <Stack.Screen 
            name="FriendList" 
            component={FriendListScreen} 
            options={{ title: '好友列表' }} 
          />
          <Stack.Screen 
            name="FriendComparison" 
            component={FriendComparisonScreen} 
            options={{ title: '好友数据对比' }} 
          />
          <Stack.Screen 
            name="Challenges" 
            component={ChallengesScreen} 
            options={{ title: '健康挑战' }} 
          />
          <Stack.Screen 
            name="ChallengeDetail" 
            component={ChallengeDetailScreen} 
            options={{ title: '挑战详情' }} 
          />
          <Stack.Screen 
            name="ExperienceSharing" 
            component={ExperienceSharingScreen} 
            options={{ title: '经验分享' }} 
          />
          <Stack.Screen 
            name="RecipeDetail" 
            component={RecipeDetailScreen} 
            options={{ title: '食谱详情' }} 
          />
          <Stack.Screen 
            name="ExperienceDetail" 
            component={ExperienceDetailScreen} 
            options={{ title: '经验详情' }} 
          />
          <Stack.Screen 
            name="SupportGroup" 
            component={SupportGroupScreen} 
            options={{ title: '互助小组' }} 
          />
          <Stack.Screen 
            name="Achievements" 
            component={AchievementsScreen} 
            options={{ title: '成就系统' }} 
          />
          <Stack.Screen 
            name="AchievementDetail" 
            component={AchievementDetailScreen} 
            options={{ title: '成就详情' }} 
          />
          <Stack.Screen 
            name="Rankings" 
            component={RankingsScreen} 
            options={{ title: '排行榜' }} 
          />
        </Stack.Navigator>
      </SafeAreaView>
    </NavigationContainer>
  );
};

export default App; 